import { Layout } from 'antd'
import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { Profile } from '../Users/Profile'
import { UserProfileView } from '../Users/UserProfileView'
import { AdminGuardedRoute } from '../components/AdminGuardedRoute'
import { ClientDetailPage } from './Client/ClientDetailPage'
import { ClientManagementPage } from './Client/ClientMangementPage'
import { HomepageFeaturedContent } from './HomepageFeaturedContent'
import { ManageUserPage } from './ManageUserPage'
import { OrganizationDetailPage } from './Organization/OrganizationDetailPage'
import { Users } from './Users'
import { MarkupRules } from './MarkupRules/MarkupRules'

export const ManagePage: React.FC = () => {
  return (
    <Layout.Content>
      <Routes>
        <Route
          path="/customer"
          element={
            <AdminGuardedRoute>
              <ClientManagementPage />
            </AdminGuardedRoute>
          }
        />
        <Route path="/customer/:customerId" element={<ClientDetailPage />} />
        <Route path="/customer/:customerId/markup-rules" element={<MarkupRules />} />
        <Route path="/customer/:customerId/organization/:organizationId" element={<OrganizationDetailPage />} />
        <Route path="/users" element={<Users />} />
        <Route path="/users/:id" element={<ManageUserPage />} />
        <Route path="/homepage/featured-contents" element={<HomepageFeaturedContent />} />
      </Routes>
    </Layout.Content>
  )
}

export const UserPage: React.FC = () => {
  return (
    <Layout.Content>
      <Routes>
        <Route path="/:id/edit" element={<Profile />} />
        <Route path="/:id" element={<UserProfileView />} />
      </Routes>
    </Layout.Content>
  )
}
